import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

// Migration FCA-6766 / FCA-6853: only "/get_list" is migrated; other
// listEndPoint values (e.g. "/image_list") must stay on Ruby until their slice.
export const getListForCommonFilter = (params, listEndPoint) => {
    const endpoint = listEndPoint ? listEndPoint : "/get_list";
    const gateway = endpoint === "/get_list" && isEnabled("migrate_assets_crud") ? fcaFastApi : fcaGateWay;
    return gateway.get(`${serviceEndpoints.assetEndPoints.assets}${endpoint}`, {
        params
    });
};

// Migration FCA-6766 / FCA-6854: assets paginated index behind migrate_assets_crud (fail-safe OFF => Ruby).
export const getDataList = params =>
    (isEnabled("migrate_assets_crud") ? fcaFastApi : fcaGateWay).get(`${serviceEndpoints.assetEndPoints.assets}`, {
        params
    });
export const getChartAssetDataList = params => fcaGateWay.get(`${serviceEndpoints.assetEndPoints.chartAssets}`, { params });

// Migration FCA-6766 / FCA-6852: asset CRUD (create/show/update/delete) behind
// migrate_assets_crud (fail-safe OFF => Ruby). Image endpoints stay on Ruby
// until their slices.
export const addData = params =>
    (isEnabled("migrate_assets_crud") ? fcaFastApi : fcaGateWay).post(`${serviceEndpoints.assetEndPoints.assets}`, params);
export const getDataById = id =>
    (isEnabled("migrate_assets_crud") ? fcaFastApi : fcaGateWay).get(`${serviceEndpoints.assetEndPoints.assets}/${id}`);

export const updateData = (id, params) =>
    (isEnabled("migrate_assets_crud") ? fcaFastApi : fcaGateWay).patch(`${serviceEndpoints.assetEndPoints.assets}/${id}`, params);

export const deleteData = (id, params) =>
    (isEnabled("migrate_assets_crud") ? fcaFastApi : fcaGateWay).delete(`${serviceEndpoints.assetEndPoints.assets}/${id}`, { params });
// Migration FCA-6766 / FCA-6856: restore soft-deleted asset behind
// migrate_assets_crud (fail-safe OFF => Ruby).
export const restoreData = id =>
    (isEnabled("migrate_assets_crud") ? fcaFastApi : fcaGateWay).patch(`${serviceEndpoints.assetEndPoints.assets}/${id}/restore`);

export const exportData = params =>
    fcaReportGateway.post(`${serviceEndpoints.assetEndPoints.exportExcel}`, params, {
        method: "POST",
        responseType: "blob"
    });

export const exportCustomExcel = params =>
    fcaGateWay.get(`${serviceEndpoints.assetEndPoints.assets}/custom_export_xl`, {
        method: "GET",
        responseType: "blob",
        params
    });

// Migration FCA-6766 / FCA-6855: per-asset audit logs behind migrate_assets_crud
// (fail-safe OFF => Ruby). restoreDataLog/deleteDataLog hit /api/v1/logs/... (a
// different controller) and stay on Ruby — not part of this migration group.
export const getAllDataLogs = (id, params) => {
    return (isEnabled("migrate_assets_crud") ? fcaFastApi : fcaGateWay).get(
        `${serviceEndpoints.assetEndPoints.assets}/${id}/logs`,
        { params }
    );
};

export const restoreDataLog = id => fcaGateWay.patch(`${serviceEndpoints.assetEndPoints.logs}/${id}/restore`);

export const deleteDataLog = id => fcaGateWay.delete(`${serviceEndpoints.assetEndPoints.logs}/${id}`);

export const getDropdownList = (level, params, clientStandardParam, isSurvey, p_id, isMobileAsset) =>
    level === "regions"
        ? isSurvey
            ? fcaFastApi.get(`${serviceEndpoints.assetEndPoints.dropdown.survey_dropdowns}`, { params })
            : fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.regionsByClient}/${params.client_id}/regions`)
        : level === "sites"
          ? isSurvey
              ? fcaFastApi.get(`${serviceEndpoints.assetEndPoints.dropdown.survey_dropdowns}`, { params })
              : fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.regions}/${params.region_id}/sites`)
          : level === "buildings"
            ? isSurvey
                ? fcaFastApi.get(`${serviceEndpoints.assetEndPoints.dropdown.survey_dropdowns}`, { params })
                : (({ site_id, ...rest }) =>
                      fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.sites}/${site_id}/buildings_dropdown`, { params: rest }))(params)
            : level === "additions"
              ? isSurvey
                  ? fcaFastApi.get(`${serviceEndpoints.assetEndPoints.dropdown.survey_dropdowns}`, { params })
                  : fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.buildings}/${params.building_id}/additions`)
              : level === "floors"
                ? isSurvey
                    ? fcaFastApi.get(`${serviceEndpoints.assetEndPoints.dropdown.survey_dropdowns}`, { params })
                    : fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.buildings}/${params.building_id}/floors`)
                : level === "manufacturers"
                  ? fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown.manufacturers}`, { params })
                  : level === "client_standards"
                    ? fcaFastApi.get(`${serviceEndpoints.assetEndPoints.dropdown.client_standards}${params?.client_id}`, {
                          params: clientStandardParam
                      })
                    : level === "building_types"
                      ? fcaGateWay.get(`${serviceEndpoints.buildingEndPoints.getBuildingTypesBasedOnClient}/building_types_dropdown`, { params })
                      : level === "trades" && isMobileAsset
                        ? fcaGateWay.get(`${serviceEndpoints.projectEndPoints.getProjectById}/${p_id}/trades_dropdown`, { params })
                        : level === "systems" && isMobileAsset
                          ? fcaGateWay.get(`${serviceEndpoints.projectEndPoints.getProjectById}/${p_id}/systems_dropdown`, { params })
                          : level === "sub_systems" && isMobileAsset
                            ? fcaGateWay.get(`${serviceEndpoints.projectEndPoints.getProjectById}/${p_id}/sub_systems_dropdown`, { params })
                            : level === "project_buildings"
                              ? (({ project_id, ...rest }) =>
                                    fcaGateWay.get(`${serviceEndpoints.projectEndPoints.getProjectById}/${project_id}/buildings_dropdown`, {
                                        params: rest
                                    }))(params)
                              : level === "project_sites"
                                ? (({ project_id, ...rest }) =>
                                      fcaGateWay.get(`${serviceEndpoints.projectEndPoints.getProjectById}/${project_id}/sites_dropdown`, {
                                          params: rest
                                      }))(params)
                                : fcaGateWay.get(`${serviceEndpoints.assetEndPoints.dropdown[level]}`, { params });

//Asset Image
export const getAllImages = (id, params) => fcaGateWay.get(`${serviceEndpoints.assetEndPoints.assets}/${id}/images`, { params });
export const uploadImage = (imageData, id) => fcaGateWay.post(`${serviceEndpoints.assetEndPoints.assets}/${id}/upload`, imageData);
export const updateAssetImage = imageData => fcaGateWay.patch(`${serviceEndpoints.assetEndPoints.assets}/${imageData.id}/update_image`, imageData);
export const deleteImages = id => fcaGateWay.delete(`${serviceEndpoints.assetEndPoints.assets}/${id}/remove_image`);
export const exportAssetReportPdf = params =>
    fcaReportGateway.post(`${serviceEndpoints.assetEndPoints.getPdfforReport}`, params, { method: "POST", responseType: "blob" });
export const exportAssetReportWord = params =>
    fcaReportGateway.post(`${serviceEndpoints.assetEndPoints.getWordforReport}`, params, { method: "POST", responseType: "blob" });

export const uploadExcelData = params => fcaGateWay.post(`${serviceEndpoints.assetEndPoints.uploadExcelData}`, params);
export const uploadSmartExcelData = params => fcaFastApi.post(`${serviceEndpoints.assetEndPoints.uploadSmartExcelData}`, params);
export const uploadSpecialExcelData = params => fcaGateWay.post(`${serviceEndpoints.assetEndPoints.uploadSpecialExcelData}`, params);
export const getExportProperties = params => fcaReportGateway.get(`${serviceEndpoints.assetEndPoints.getExportProperties}`, { params });
export const postExportProperties = params => fcaReportGateway.post(`${serviceEndpoints.assetEndPoints.postExportProperties}`, params);

export const getAllAssetIds = params => fcaGateWay.get(`${serviceEndpoints.assetEndPoints.getAllAssetIds}`, { params });

export const getAssetCommonDataByIds = params => fcaGateWay.post(serviceEndpoints.assetEndPoints.getAssetCommonDataByIds, params);

export const updateMultiAssets = params => fcaGateWay.patch(serviceEndpoints.assetEndPoints.updateMultiAssets, params);

export const getAssetDynamicFields = params => fcaGateWay.get(`${serviceEndpoints.assetEndPoints.getAssetDynamicFields}`, { params });

export const saveFavorites = params => fcaReportGateway.post(`${serviceEndpoints.assetEndPoints.saveFavorites}`, params);
export const getFavorites = params => fcaReportGateway.get(`${serviceEndpoints.assetEndPoints.getFavorites}`, { params });
export const getSmartImportFields = params => fcaFastApi.get(`${serviceEndpoints.assetEndPoints.smartImportFields}`, { params });
export const saveSmartImportFields = data => fcaFastApi.post(`${serviceEndpoints.assetEndPoints.saveSmartImportFields}`, data);
export const getExportGroupingDropdown = params =>
    isEnabled("migrate_report_reads")
        ? fcaFastApi.get(`${serviceEndpoints.assetEndPoints.getExportGroupingDropdownFastApi}`, { params })
        : fcaReportGateway.get(`${serviceEndpoints.assetEndPoints.getExportGroupingDropdown}`, { params });
